import ReactDOM from 'react-dom';
import ComponentLoader from '../componentLoader/componentLoader';

const TableLoading = ({ tableElement }) => {
  if (tableElement && tableElement.current) return ReactDOM.createPortal(<ComponentLoader />, tableElement.current.element);
  return null;
};

export default TableLoading;
